import React, { memo } from 'react';
import { Route } from 'react-router-dom';
import SwitchWith404 from './SwitchWith404';
import SubRouter from './SubRouter';
import WithAuth from 'components/shared/auth/hocs/withAuth';
import { ActivationGuard } from '../../shared/auth/hocs/ActivationGuard';
import { StackConfig } from '../type';

interface RootStackProps {
    stack: StackConfig[];
}

const getStack = ({ stack, auth, isPublic }: StackConfig) => {
    if (isPublic) {
        return <SubRouter routes={stack} />;
    }
    if (!auth) {
        return (
            <ActivationGuard>
                <SubRouter routes={stack} />
            </ActivationGuard>
        );
    }
    return (
        <WithAuth>
            <SubRouter routes={stack} />
        </WithAuth>
    );
};

const RootStack = ({ stack }: RootStackProps) => {
    const renderStack = stack.map(item => (
        <Route key={item.base} path={`${item.base}/*`} element={getStack(item)} />
    ));

    return <SwitchWith404>{renderStack}</SwitchWith404>;
};

export default memo(RootStack);
